import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

import Checkbox from "../Checkbox";
import CustomDropdown from "../CustomDropdown";
import './multiple_selector.scss';

function MultipleSelector(
    {
        id,
        trigger,
        items,
        selected,
        container_class = '',
        trigger_class = '',
        content_class = '',
        item_class = '',
        open_on_mouse_over = false,
        close_on_mouse_leave = false,
        no_wrap = false,
        disabled = false,
        match_dropdown_width = false,
        item_id_key = 'id',
        item_name,
        callback,
        show_all_option = false,
        use_search = false,
        max_dropdown_height,
        use_arrow = true
    }
) {
    const [q, setQ] = useState('');

    function onItemCheck(id) {
        return () => {
            let selected_new = [];
            if ('all' === id) {
                if (selected.length !== items.length) {
                    items.map(item => selected_new.push(item[item_id_key]));
                }
            } else {
                selected_new = JSON.parse(JSON.stringify(selected));
                if (selected_new.indexOf(id) < 0) {
                    selected_new.push(id);
                } else {
                    selected_new.splice(selected_new.indexOf(id), 1);
                }
            }
            callback(selected_new);
        }
    }

    function renderAllOption() {
        return (
            <Checkbox
                id={'item-all'}
                checked={items.length === selected.length}
                label={'All ' + item_name + 's'}
                toggle={onItemCheck('all')}/>
        );
    }

    function renderSearchBar() {
        return (
            <div className='multiple-selector-search-bar'>
                <input
                    className='multiple-selector-search-bar-input'
                    placeholder='Search'
                    value={q}
                    onChange={event => setQ(event.target.value)}/>
            </div>
        );
    }

    function renderItems() {
        const dropdown_items = {};
        if (use_search === true && items.length > 15) {
            dropdown_items[0] = renderSearchBar()
        }
        if (show_all_option) {
            dropdown_items[1] = renderAllOption()
            dropdown_items[2] = (<hr className='divider'/>);
        }

        items.filter(item => {
            if (!q || q.length <= 0) {
                return true;
            }

            return item.label.toString().toLowerCase().includes(q.toString().toLowerCase());
        }).map((item, index) => {
            dropdown_items['z' + index] = (
                <Checkbox
                    checked={selected.indexOf(item[item_id_key]) >= 0}
                    label={item.label}
                    toggle={onItemCheck(item[item_id_key])}/>
            )
        });

        return dropdown_items;
    }

    useEffect(() => {
        return () => {
            setQ('');
        }
    }, []);

    return (
        <CustomDropdown
            id={id}
            trigger={trigger}
            no_wrap={no_wrap}
            container_class={container_class + ' multiple-selector-container'}
            trigger_class={trigger_class + ' multiple-selector-trigger flex-row'}
            content_class={content_class + ' multiple-selector-content'}
            item_class={item_class + ' multiple-selector-content-item'}
            items={renderItems()}
            disabled={disabled}
            match_dropdown_width={match_dropdown_width}
            open_on_mouse_over={open_on_mouse_over}
            close_on_mouse_leave={close_on_mouse_leave}
            ignore_targets={[
                'mindsets-checkbox-label',
                'mindsets-checkbox-tick',
                'multiple-selector-search-bar',
                'multiple-selector-search-bar-input',
                'mindsets-checkbox'
            ]}
            max_dropdown_height={max_dropdown_height}
            use_arrow={use_arrow}
        />
    );
}

MultipleSelector.propTypes = {
    //CustomDropdown props
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    trigger: PropTypes.element.isRequired,
    container_class: PropTypes.string,
    trigger_class: PropTypes.string,
    content_class: PropTypes.string,
    item_class: PropTypes.string,
    open_on_mouse_over: PropTypes.bool,
    close_on_mouse_leave: PropTypes.bool,
    no_wrap: PropTypes.bool,
    disabled: PropTypes.bool,
    before_trigger: PropTypes.any,
    after_trigger: PropTypes.any,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    match_dropdown_width: PropTypes.bool,
    ignore_targets: PropTypes.arrayOf(PropTypes.string),
    max_dropdown_height: PropTypes.number,
    use_arrow: PropTypes.bool,
    //Own props
    items: PropTypes.array.isRequired,
    selected: PropTypes.array.isRequired,
    item_id_key: PropTypes.string,
    item_name: PropTypes.string.isRequired,
    callback: PropTypes.func.isRequired,
    show_all_option: PropTypes.bool,
    use_search: PropTypes.bool
};

export default MultipleSelector;
